import type {
  CompanyAnalysisResponseDto,
  CompanyPeriodResponseDto,
  GetCompanyListItemResponseDto,
} from "@/spz-api/model";

export interface ControlCompanyListItem {
  id: string;
  name: string;
  periods: CompanyPeriodListItem[];
}

export interface CompanyListItem {
  id: string;
  name: string;
  defaultOwner?: string | null;
  lastExecution?: Date | null;
  analysisCount: number;
}

export interface CompanyPeriodListItem {
  id: string;
  name: string;
  startAt: Date;
  endAt: Date;
  analysis: CompanyAnalysisListItem[];
}

export interface CompanyAnalysisListItem {
  id: string;
  name: string;
  createdAt: Date;
}

export class ControlCompanyMapper {
  static toListItem(
    data: GetCompanyListItemResponseDto,
  ): ControlCompanyListItem {
    return {
      id: data.id,
      name: data.name,
      periods: ControlCompanyMapper.toPeriodListItems(data.periods),
    };
  }

  static toControlCompanyListItems(
    dtos: GetCompanyListItemResponseDto[],
  ): ControlCompanyListItem[] {
    return dtos.map(ControlCompanyMapper.toListItem);
  }

  static toPeriodListItem(
    data: CompanyPeriodResponseDto,
  ): CompanyPeriodListItem {
    return {
      id: data.id,
      name: data.name,
      startAt: new Date(data.startAt),
      endAt: new Date(data.endAt),
      analysis: ControlCompanyMapper.toAnalysisListItems(data.analysis),
    };
  }

  static toAnalysisListItem(
    data: CompanyAnalysisResponseDto,
  ): CompanyAnalysisListItem {
    return {
      id: data.id,
      name: data.name,
      createdAt: new Date(data.createdAt),
    };
  }

  static toPeriodListItems(
    dtos: CompanyPeriodResponseDto[],
  ): CompanyPeriodListItem[] {
    return dtos.map(ControlCompanyMapper.toPeriodListItem);
  }

  static toAnalysisListItems(
    dtos: CompanyAnalysisResponseDto[],
  ): CompanyAnalysisListItem[] {
    return dtos.map(ControlCompanyMapper.toAnalysisListItem);
  }
}

export class CompanyMapper {
  static toListItem(data: GetCompanyListItemResponseDto): CompanyListItem {
    return {
      id: data.id,
      name: data.name,
      defaultOwner: data.defaultOwner ?? null,
      lastExecution: data.lastExecution ? new Date(data.lastExecution) : null,
      analysisCount: data.analysisCount,
    };
  }

  static toCompanyListItems(
    dtos: GetCompanyListItemResponseDto[],
  ): CompanyListItem[] {
    return dtos.map(CompanyMapper.toListItem);
  }
}
